import React from 'react';
import { Button } from 'react-bootstrap';
//ICONOS
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const Volver = (props) => {
    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    return (
        <>
            {props.ultimoPaso ?
                props.currentStep > 1 &&
                <Button className="mr-4" variant="secondary" size="sm" style={{ width: 115 }}
                    onClick={() => {
                        scrollTop();
                        setTimeout(() => {
                            props.goToStep(props.ultimoPaso);
                        }, 400);
                    }}
                ><ArrowBackIcon /> Volver</Button>
                :
                props.currentStep > 1 &&
                <Button className="mr-4" variant="secondary" size="sm" style={{ width: 115 }}
                    onClick={() => {
                        scrollTop();
                        setTimeout(() => {
                            props.previousStep();
                        }, 400);
                    }}
                ><ArrowBackIcon /> Volver</Button>
            }
        </>
    )
}

export default Volver;